/**
 * ChatIcon — sanitized from `assets/newSvg/chat.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ChatIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M2,6 C2,4.34315 3.34315,3 5,3 L19,3 C20.6569,3 22,4.34315 22,6 L22,16 C22,17.6569 20.6569,19 19,19 L7.33333,19 L4,21.5 C3.17596,22.118 2,21.5301 2,20.5 L2,6 Z M7,9 C7,8.44772 7.44772,8 8,8 L16,8 C16.5523,8 17,8.44772 17,9 C17,9.55228 16.5523,10 16,10 L8,10 C7.44772,10 7,9.55228 7,9 Z M8,12 C7.44772,12 7,12.4477 7,13 C7,13.5523 7.44772,14 8,14 L11,14 C11.5523,14 12,13.5523 12,13 C12,12.4477 11.5523,12 11,12 L8,12 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ChatIcon;
